import { useParams, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useInsightsData, EventPost } from "../hooks/useInsightsData";
import GlowEffect from "../components/common/GlowEffect";
import ImageWithDescription from "../components/common/ImageWithDescription";

export default function EventsContentsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data } = useInsightsData();
  
  const eventData = data.eventsPosts.find((p: EventPost) => p.id === id);

  if (!eventData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
          <button
            onClick={() => navigate("/insights")}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to Insights
          </button>
        </div>
      </div>
    );
  }

  return (
    <section className="pt-20 pb-10">
      <GlowEffect />
      {/* Close Button */}
      <div className="absolute top-0 right-16 z-50">
        <button onClick={() => navigate("/insights")}>
          <X
            className="absolute top-8 w-12 h-12 text-white rounded-full flex items-center justify-center transition-all duration-300"
            size={24}
          />
        </button>
      </div>
      <img
        className="w-full h-[500px] mb-10 object-cover"
        src={eventData?.image}
        alt="event-image"
      />
      <section className="px-6 md:px-14">
        <div>
          <h1 className={`text-3xl grid ${eventData.titlePosition === "left" ? "grid-cols-1 md:grid-cols-[1fr_0.5fr]" : "grid-cols-1 md:grid-cols-[0.5fr_1fr]"} md:text-[65px] leading-tight font-lato ${eventData.titlePosition === "right" ? "text-right" : "text-left"}`}>
            {eventData.titlePosition === "left" ? (
              <>
                {eventData.title}
                <p className="hidden md:block"></p>
              </>
            ) : (
              <>
                <p className="hidden md:block"></p>
                {eventData.title}
              </>
            )}
          </h1>
          
        </div>
        
        {/* Image with Description Content */}
        {eventData.content && (
          <div className="mt-12">
            <ImageWithDescription content={eventData.content} />
          </div>
        )}
      </section>
    </section>
  );
}
